import classnames from 'classnames'
import { TFunction, useTranslation } from 'next-i18next'
import React from 'react'

import { useFormatPrice } from '@src/blocks/currency'
import { Button, BUTTON_SIZE, BUTTON_TYPES } from '@src/quince-components/src'

import { OptionProp } from '../OptionSelector.constant'

import styles from './packOption.module.scss'

type FormatPriceFn = ReturnType<typeof useFormatPrice>

type PackOptionProps = {
  value: string
  quantityInPack?: number
} & Pick<OptionProp, 'isSelected' | 'salePrice' | 'className'>

const PackOption = ({ value, quantityInPack, isSelected, className: _className, salePrice }: PackOptionProps) => {
  const { t } = useTranslation('common')
  const formatPrice = useFormatPrice()
  return (
    <Button
      type={BUTTON_TYPES.OUTLINED}
      size={BUTTON_SIZE.MEDIUM}
      disabled={false}
      round={false}
      className={classnames(styles.option, isSelected && styles.selected_option)}
    >
      {renderButtonValue(value, salePrice, quantityInPack, t, formatPrice)}
    </Button>
  )
}

const renderButtonValue = (
  value: string,
  salePrice: number | undefined,
  quantityInPack: number | undefined,
  t: TFunction,
  formatPrice: FormatPriceFn,
) => {
  const salePriceValue = salePrice && (Math.round(salePrice * 100) / 100).toFixed(2)
  const priceForEachItem = salePriceValue && quantityInPack && (parseFloat(salePriceValue) / quantityInPack).toFixed(2)

  return (
    <>
      <span>
        {value} {salePriceValue && `$${salePriceValue}`}
      </span>
      {priceForEachItem && (
        <span className={styles.itemPrice}>{t('var1_ea', { var1: formatPrice(priceForEachItem) })}</span>
      )}
    </>
  )
}

export default PackOption
